/** Vditor 静态资源根路径（由 vite-plugin-vditor-static 提供，不走外网 CDN） */
export const VDITOR_ASSET_BASE = '/vditor'
export const VDITOR_CONTENT_THEME = `${VDITOR_ASSET_BASE}/dist/css/content-theme`
